import { createFileRoute } from '@tanstack/react-router';

import { VideoTypeSettings } from '@/pages/record-and-send/setup/video-type-settings';

function VideoTypeSettingsTab() {
	const { videoTypeId } = Route.useParams();
	return <VideoTypeSettings videoTypeId={videoTypeId} />;
}

export const Route = createFileRoute('/_authenticated/_app/record-and-send/video-types/$videoTypeId/settings')({
	component: VideoTypeSettingsTab,
});
